export default {
  AirTableForm: 'airtableForm',
  BikeCtaBreaker: 'ctaBreaker',
  Carousel: 'carousel',
  CtaBreaker: 'universalCtaBreaker',
  FAQComponent: 'faqComponent',
  FeaturedArticles: 'featuredArticles',
  FeaturesComponent: 'features',
  FooterComponent: 'footer',
  Hero: 'appHero',
  LegalComponent: 'legalComponent',
  LocationsMap: 'locationsMap',
  Media: 'media',
  Navbar: 'navbar',
  Offerings: 'offerings',
  OpenSourceCreditsEntries: 'openSourceCreditsEntries',
  PdfDisplay: 'pdfDisplay',
  PDPWell: 'pdpWell',
  RedirectComponent: 'redirectComponent',
  Reviews: 'memberReviews',
  RichtextComponent: 'richTextComponent',
  SalesforceChat: 'salesforceChat',
  SectionComponent: 'section',
  Specifications: 'specificationsComponent',
  Testimonials: 'testimonials',
  TitleBanner: 'titleBanner',
  TwoUp: 'twoUp',
  VerticalSpacerComponent: 'verticalSpacer',
  VideoTiles: 'videoTiles'
};
